export default {
	list: 'UnitClass',
	grid: {
		pageable: false,
		editable: true
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'ProgramId',
			type: 'number',
			title: 'Program Id',
			width: 100,
			hidden: true
		},
		UnitClass: {
			class: 'choice',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 125,
			hidden: false
		},
		PartnerType: {
			class: 'choice',
			dataName: 'PartnerType',
			type: 'string',
			dropdown:true,
			title: 'Partner Type',
			width: 150,
			hidden: false
		},
		UnitPrice: {
			class: 'value',
			dataName: 'UnitPrice',
			type: 'number',
			title: 'Unit Price',
			format:"{0:c}",
			validation: { min: 0.00, required: true},
			width: 125,
			hidden: false
		},
		Ownership: {
			class: 'value',
			dataName: 'Ownership',
			type: 'number',
			editorType: 'percentEditor',
			template : '#= kendo.toString(Ownership*100, "n2") #' + ' %',
			//template: '#=kendo.format("{0:p}", Ownership/100)#',
			//format:"{0:p}",
			//validation: { min: 0.0, max:1 ,step: 0.01},
			title: 'Ownership',
			width: 125,
			hidden: false
		},
		InitialAwardDate: {
			class: 'value',
			dataName: 'InitialAwardDate',
			type: 'date',
			title: 'Initial Award Date',
			width: 150,
			hidden: false
		},
		SubjectToVesting: {
			class: 'choice',
			dataName: 'SubjectToVesting',
			type: 'string',
			title: 'Subject To Vesting',
			width: 150,
			hidden: false,
			dropdown:true,
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 400,
			hidden: false
		},
		UnitIssued:{
			class: 'value',
			dataName: 'UnitIssued',
			type: 'string',
			title: 'Unit Issued',
			width: 200,
			hidden: true,
			editable:false,
			readOnly:true
		}
	}
}